/* @flow */
import cx from 'classnames';
import * as React from 'react';
import gql from 'graphql-tag';
import classesSettingsFragment from 'groups/fragments/classesSettingsFragment.gql';
import GradeLevelPicker from 'components/GradeLevelPicker.jsx';
import Group from 'entities/Group';
import MediaObject from 'components/MediaObject.jsx';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import SchoolPicker from 'components/SchoolPicker.jsx';
import SubjectPicker from 'components/SubjectPicker.jsx';
import AffiliationStore from 'stores/AffiliationStore';
import ToastActions from 'actions/ToastActions';
import Text from 'components/Text.jsx';
import { UNAFFILIATED } from 'constants/OrganizationConstants';
import { graphql } from 'react-apollo';

import './styles/TeacherInfoCollectionRow.scss';

type Props = {
  group: Object,
  onValid: () => void,
  onInvalid: () => void,
  saveClass: (input: Object) => Promise<*>,
};

export class TeacherInfoCollectionRow extends React.Component<Props, $FlowFixMeState> {
  state = {
    isSubjectValid: this.props.group.subject !== null,
  };

  componentWillMount() {
    this.updateValidity();
  }

  selectSchool = (organizationId: ?number) => {
    this.saveClass({ organization_id: organizationId });
  };

  saveGradeLevels = (gradeLevels: string[]) => {
    this.saveClass({ grades: gradeLevels });
  };

  saveSubject = (subject: ?string) => {
    this.setState({ isSubjectValid: true });
    this.saveClass({ subject });
  };

  saveClass = (input: Object) => {
    this.props
      // TeacherInfoCollectionRow is used only in TeacherInfoCollectionModal which never sends this prop
      // $FlowFixMe WTF is this supposed to do?
      .saveClass(this.props.group.id, input)
      .then(() => this.updateValidity())
      .catch(err => {
        ToastActions.showErrorToast(err.message);
        throw err;
      });
  };

  updateValidity = () => {
    if (this.hasGradeError() || !this.state.isSubjectValid) {
      this.props.onInvalid();
    } else {
      this.props.onValid();
    }
  };

  hasGradeError(): boolean {
    const { group } = this.props;
    return group.organization !== null && group.grades.length === 0;
  }

  render() {
    const { group } = this.props;
    const schoolSuggestions = AffiliationStore.getMemberOrganizations();
    const groupEntity = Group.fromJSON(group);

    if (!group.has_children) {
      schoolSuggestions.push(UNAFFILIATED);
    }

    return (
      <tr key={group.id} className="TeacherInfoCollectionRow">
        <td className="TeacherInfoCollectionRow-cell">
          <MediaObject center gutter="xsmall">
            <GroupAvatar group={groupEntity} size="small" />
            <Text truncate>
              <GroupName group={groupEntity} />
            </Text>
          </MediaObject>
        </td>
        <td className="TeacherInfoCollectionRow-cell">
          <SchoolPicker
            onSelect={this.selectSchool}
            onClear={() => {}}
            suggestions={schoolSuggestions}
            schoolId={group.organization ? group.organization.id : undefined}
            selectedSchool={group.organization ? undefined : UNAFFILIATED}
          />
        </td>
        <td
          className={cx(
            'TeacherInfoCollectionRow-cell',
            this.hasGradeError() ? 'TeacherInfoCollectionRow-cell--error' : ''
          )}>
          <GradeLevelPicker
            onClose={this.saveGradeLevels}
            initialGrades={group.grades.map(g => g.code)}
          />
        </td>
        <td
          className={cx(
            'TeacherInfoCollectionRow-cell',
            this.state.isSubjectValid ? '' : 'TeacherInfoCollectionRow-cell--error'
          )}>
          <SubjectPicker
            onChange={this.saveSubject}
            initialSubject={group.subject && group.subject.subject_code}
          />
        </td>
      </tr>
    );
  }
}

const withMutations = graphql(
  gql`
    ${classesSettingsFragment}

    mutation updateClass($classId: Int!, $input: UpdateClassInput!) {
      updateClass(classId: $classId, input: $input) {
        class {
          ...classesSettings
        }
        error {
          message
        }
      }
    }
  `,
  {
    props({ mutate }) {
      return {
        saveClass(classId: Backbone$Id, input: Object) {
          return mutate({ variables: { classId, input } }).then(({ data: { updateClass } }) => {
            if (updateClass.error) {
              throw new Error(updateClass.error.message);
            }
          });
        },
      };
    },
  }
);

export default withMutations(TeacherInfoCollectionRow);
